<template>
  <div>
    <full-page-modal
      v-show="windowWidth < 1024"
      header-text="Browser Window Too Small"
      primary-button-text="Back"
      content-text="Your browser's window size is too small. The test simulation is designed to designed to emulate the actual test which requires a regular sized monitor. Please use this on a larger screen or maximize your browsers window."
      @primary-button-click="goBack"
    ></full-page-modal>
  </div>
</template>

<script>
import FullPageModal from '@/components/sims/FullPageModal.vue';


export default {
  components: {
    FullPageModal,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  created() {
    window.addEventListener('resize', this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener('resize', this.myEventHandler);
  },
  methods: {
    myEventHandler(e) {
      this.windowWidth = window.innerWidth;
    },
    goBack: function() {
      this.$router.go(-1);
    },
  },
};
</script>
